import React, {Component} from 'react';
import {Card, Col, Row} from 'antd';
import {connect} from 'react-redux';

import DescriptionList from '@comm/DescriptionList';
import {queryInvoiceType} from '@api/core/dict';
import {queryCustomAvailable, queryCustomDoing} from '@api/incubator/invoice';
import util from '@util/index';
import TableFile from '../comm/TableFile';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
      invoiceType: {},
      cusAvailable: 0,
      cusDoing: 0,
    };
  }

  componentDidMount() {
    this.getInvoiceType();
    this.getCustomAvailable();
    this.getCustomDoing();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        const invoiceType = {};
        res.data.forEach(item => {
          invoiceType[item.value] = item.key;
        });
        this.setState({
          invoiceType,
        });
      }
    });
  };

  getCustomAvailable = () => {
    const { data } = this.props;
    queryCustomAvailable({
        customUuid: data.customUuid,
        incubatorUuid: data.incubatorUuid,
        type: data.type,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            cusAvailable: res.data.avaliable,
          });
        }
      });
  };

  getCustomDoing = () => {
    const { data } = this.props;
    queryCustomDoing({
        customUuid: data.customUuid,
        incubatorUuid: data.incubatorUuid,
        type: data.type,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            cusDoing: res.data.doing,
          });
        }
      });
  };

  handleVisible = flag => {};

  handleSeatVisible = flag => {};

  render() {
    const { dataItem, invoiceType, cusAvailable, cusDoing } = this.state;
    return (
      <div className="form-open mb16">
        <Card title="开票详情">
          <Row>
            <Col span={12}>
              <DescriptionList size="large" col={1}>
                <Description term="客户名称">{dataItem.custom}</Description>
                <Description term="纳税人识别号">{dataItem.idCode}</Description>
                {dataItem.type === '0' ? (
                  <Description term="地址及电话">{dataItem.link}</Description>
                ) : null}
                {dataItem.type === '0' ? (
                  <Description term="开户行及账号">{dataItem.bankCode}</Description>
                ) : null}
              </DescriptionList>
            </Col>
            <Col span={12}>
              <DescriptionList size="large" col={1}>
                <Description term="开票公司">{dataItem.company}</Description>
                <Description term="开票类型">{invoiceType[dataItem.type]}</Description>
                <Description term="开票内容">{dataItem.content}</Description>
                <Description term="开票金额">{dataItem.price}</Description>
                <Description>
                  <span style={{ color: 'red' }}>
                    可开票金额:
                    {cusAvailable}
                    {cusDoing ? `（审核中：${util.numberFormat(cusDoing)}元）` : null}
                  </span>
                </Description>
              </DescriptionList>
            </Col>
          </Row>
          <DescriptionList size="large" col={1}>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="开票说明">{dataItem.reason}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="开票备注">{dataItem.remark}</Description>
          </DescriptionList>
        </Card>
        {dataItem.codeNo ? (
          <Card title="领票信息">
            <DescriptionList size="large" col={2}>
              <Description term="发票编号">{dataItem.codeNo}</Description>
              <Description term="领票人">{dataItem.receiver}</Description>
            </DescriptionList>
          </Card>
        ) : null}
        {dataItem.invalid ? (
          <Card title="作废信息">
            <DescriptionList size="large" col={1}>
              <Description term="开票状态">已作废</Description>
              <Description term="作废原因">{dataItem.invalidReason}</Description>
            </DescriptionList>
          </Card>
        ) : null}
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/FormOpen.js